<template>
    <div aria-live="polite" aria-atomic="true" class="nebula-screenreader-only">
        <span v-if="isLoading">{{ $t('Loading New Page') }}</span>
    </div>
    <PageWrapper padded contained v-if="isLoading">
        <div class="global-spinner" aria-hidden="true">
            <NebulaLoadingSpinner isVisible variant="inline" />
            <DECareerConnectLogo class="global-spinner__logo" />
        </div>
    </PageWrapper>
</template>

<script setup>
import PageWrapper from '@/components/shared/layout/PageWrapper.vue';
import { NebulaLoadingSpinner } from '@discoveryedu/nebula-components';
import DECareerConnectLogo from '@/components/shared/tokens/DECareerConnectLogo.vue';
defineProps({
    isLoading: {
        type: Boolean,
        default: true,
    },
});
</script>

<style lang="stylus">
.global-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 80vh;
    width: 100%;

    &__logo {
        position: absolute;
        top: 35%; // centers logo just above the spinner
        width: 200px;
    }
}
</style>
